import { render, staticRenderFns } from "./headbox.vue?vue&type=template&id=56418786&scoped=true&"
import script from "./headbox.vue?vue&type=script&lang=js&"
export * from "./headbox.vue?vue&type=script&lang=js&"
import style0 from "./headbox.vue?vue&type=style&index=0&id=56418786&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56418786",
  null
  
)

export default component.exports